import axios from '@fs/zion-axios'
import useStateManager from './useStateManager'
import useFetchData from './useFetchData'
import { VerificationCodeInvalidError } from '../errors'
import getIdentBaseUrl from '../utils/getIdentBaseUrl'

const verifyMfaCode = async (verificationCode) => {
  try {
    await axios.post(`${getIdentBaseUrl()}/service/ident/authn/emailAuthentication/CURRENT`, {
      verificationCode,
    })
  } catch (error) {
    if (error.response?.status === 400) {
      throw new VerificationCodeInvalidError()
    }
    throw error
  }
}

const fetchMfa = async () => {
  const { data } = await axios.get(`${getIdentBaseUrl()}/service/ident/authn/emailAuthentication/CURRENT`)
  return !!data?.enrolled
}

const deactivateMfa = async () => {
  await axios.delete(`${getIdentBaseUrl()}/service/ident/authn/emailAuthentication/CURRENT`)
}

const activateMfa = async () => {
  await axios.put(`${getIdentBaseUrl()}/service/ident/authn/emailAuthentication/CURRENT`)
}

const updateMfa = async (checked, skipRequest) => {
  if (checked) {
    // Do nothing here since we are just updating local state
    // The network request was already made when submitting the verification code in the dialog
  } else if (!skipRequest) {
    await deactivateMfa()
  }
}

export default function useMfa() {
  const { data: remoteMfa, loading: mfaLoading } = useFetchData(fetchMfa, { initialData: false })

  const { state: localMfa, handleChangeState: handleChangeMfa } = useStateManager(updateMfa)
  const mfa = localMfa ?? remoteMfa

  const resetMfa = async () => {
    handleChangeMfa(false, true)
  }

  return {
    mfa,
    mfaLoading,
    handleChangeMfa,
    verifyMfaCode,
    activateMfa,
    resetMfa,
  }
}
